/* eslint-disable max-len */
import {
  webpageFacebook,
  webpageInstagram,
  webpageTwitter,
} from '../../assets';

export default [
  {
    value: 'Twitter',
    title: 'Authorize AlphaVeritas on Twitter',
    permisionText:
      'AlphaVeritas needs permission to access and publish content to Twitter on your behalf. Add your Twitter profile to monitor activity and send tweets',

    image: webpageTwitter,
  },
  {
    value: 'Instagram',
    title: 'Authorize AlphaVeritas on Instagram',
    permisionText:
      'AlphaVeritas needs permission to access and publish comments to Instagram on your behalf. Add your Instagram account to manage your profile.',
    image: webpageInstagram,
  },
  {
    value: 'Facebook',
    title: 'Authorize AlphaVeritas on Facebook',
    permisionText:
      'AlphaVeritas needs permission to access and publish content to Facebook on your behalf. To grant permission, you must be an admin for your brand’s Facebook page.',
    image: webpageFacebook,
  },
];
